module.exports = __webpack_public_path__ + "static/pfr.1d876355.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pfr.jpeg
// module id = 700
// module chunks = 114276838955818